import { jsx as _jsx } from "react/jsx-runtime";
import { OpenTab } from 'seagull/icons';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
export const TimeActivityExternalLink = (param)=>{
    let { href, accountingName, bi, testId } = param;
    const { t } = useLocaleKeys('components.billClientModal.timeActivities');
    return /*#__PURE__*/ _jsx(ExternalLinkButton, {
        bi: bi,
        href: href,
        testId: testId,
        tooltip: {
            title: t.externalLinkTooltip({
                accountingName
            }),
            placement: 'top'
        },
        openInNewTab: true,
        children: /*#__PURE__*/ _jsx(OpenTab, {
            size: 16
        })
    });
};
